import { MARKETPLACES } from '@config/constants'
import { dynamicImport, insertIf } from '@core/helpers'
import { ROUTES } from '@router'

// TODO: Add bo_merchant to the following routes
const badoomRoutesNotNamespaced = [
  {
    name: ROUTES.ADMIN.HOME,
    path: '/admin',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.PAYPAL_CONNECT_ACCOUNT,
    path: '/paypal/merchant_onboard',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.PASSWORD_RESET,
    path: '/password_reset/?m=merchant',
    meta: { rollout: false },
  },
  // Merchant product preview URL
  {
    name: ROUTES.PRODUCT.PREVIEW,
    path: '/preview/:id',
    meta: { rollout: false },
  },
]

const badoomRoutes = [
  {
    name: ROUTES.BO_MERCHANT.ROOT,
    path: '',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.SUBSCRIBE,
    path: 'subscribe',
    meta: { rollout: false },
  },

  {
    name: ROUTES.BO_MERCHANT.DASHBOARD,
    path: 'dashboard',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.SOURCING.DASHBOARD,
    path: 'sourcing/dashboard',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.SOURCING.ORDER,
    path: 'sourcing/orders/:orderId',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.SOURCING.LISTINGS,
    path: 'sourcing/listings',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.SOURCING.INVOICES,
    path: 'sourcing/invoices',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.PERFORMANCES,
    path: 'performances',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.LISTINGS.CREATE.SEARCH,
    path: 'listings/new',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.SUPPORT,
    path: 'merchant_support/FAQs',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.DOCUSIGN_CGU,
    path: 'merchant/cgu/sign',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.QUALITY_CHARTER,
    path: 'merchant_support/charter',
    meta: { rollout: false },
  },
  {
    name: ROUTES.MERCHANT_ORDERS,
    path: 'orders',
    meta: { rollout: false },
  },
  {
    name: ROUTES.CLIENTS,
    path: 'admin_tools/clients',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.PROFILE,
    path: 'profil',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.MAILBOX,
    path: 'mailbox',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.LOGOUT,
    path: 'logout',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.PAYOUT_INFORMATION,
    path: 'kyb/adyens_onboarding_page',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.OPTIONS.COMMENTS,
    path: 'options/comments',
    meta: { rollout: false },
  },
  {
    name: ROUTES.BO_MERCHANT.REVIEWS,
    path: 'reviews',
    meta: { rollout: false },
  },
]

const buybackRoutes = [
  {
    name: ROUTES.BO_MERCHANT.SOURCING.OPPORTUNITIES,
    path: 'sourcing/auctions',
    component: () => dynamicImport(import('./pages/opportunities')),
  },
  {
    name: ROUTES.BO_MERCHANT.SOURCING.ORDERS.HOME,
    path: 'sourcing-new/orders',
    component: () => dynamicImport(import('./pages/sourcing')),
    redirect: { name: ROUTES.BO_MERCHANT.SOURCING.ORDERS.ACTIVE },
    children: [
      {
        name: ROUTES.BO_MERCHANT.SOURCING.ORDERS.ACTIVE,
        path: 'active',
      },
      {
        name: ROUTES.BO_MERCHANT.SOURCING.ORDERS.ALL,
        path: 'all',
      },
      {
        name: ROUTES.BO_MERCHANT.SOURCING.ORDERS.PENDING,
        path: 'pending',
      },
    ],
  },
].map((route) => ({ ...route, meta: { ...route.meta, isBuyback: true } }))

const pricingToolRoute = [
  {
    name: ROUTES.BO_MERCHANT.PRICING_TOOL,
    path: 'pricing-tool',
    component: () => dynamicImport(import('./pages/pricing-tool')),
  },
]

const hyperwalletRoutes = [
  {
    name: ROUTES.BO_MERCHANT.OPTIONS.KYB,
    path: 'options/payment/kyb',
    component: () => dynamicImport(import('./pages/hyperwallet/kyb')),
  },
  {
    name: ROUTES.BO_MERCHANT.OPTIONS.TRANSFER_METHODS,
    path: 'options/payment/transfer-methods',
    component: () =>
      dynamicImport(import('./pages/hyperwallet/transfer-methods')),
  },
  {
    name: ROUTES.BO_MERCHANT.OPTIONS.TRANSFER_METHODS_CONFIRMATION,
    path: 'options/payment/transfer-methods/confirmation',
    component: () => dynamicImport(import('./pages/hyperwallet/confirmation')),
  },
]

const getOptionsRoutes = (marketplace) => {
  const childrenRoutes = [
    ...insertIf(marketplace === MARKETPLACES.EU, [
      {
        name: ROUTES.BO_MERCHANT.OPTIONS.MARKETS,
        path: 'markets',
        component: () => dynamicImport(import('./pages/options/tabs/markets')),
      },
    ]),
    {
      name: ROUTES.BO_MERCHANT.OPTIONS.ADDRESSES,
      path: 'addresses',
      component: () => dynamicImport(import('./pages/options/tabs/addresses')),
    },
    {
      name: ROUTES.BO_MERCHANT.OPTIONS.SHIPPING,
      path: 'shipping',
      component: () => dynamicImport(import('./pages/options/tabs/shipping')),
    },
    {
      name: ROUTES.BO_MERCHANT.OPTIONS.PAYMENT,
      path: 'payment',
      component: () => dynamicImport(import('./pages/options/tabs/payment')),
    },
    ...insertIf(marketplace === MARKETPLACES.EU, [
      {
        name: ROUTES.BO_MERCHANT.OPTIONS.PRICING,
        path: 'pricing',
        component: () => dynamicImport(import('./pages/options/tabs/pricing')),
      },
    ]),
    {
      name: ROUTES.BO_MERCHANT.OPTIONS.BACKPRICER,
      path: 'backpricer',
      component: () => dynamicImport(import('./pages/options/tabs/backpricer')),
    },
    {
      name: ROUTES.BO_MERCHANT.OPTIONS.INTEGRATIONS,
      path: 'integrations',
      component: () =>
        dynamicImport(import('./pages/options/tabs/integrations')),
    },
  ]

  return [
    {
      path: 'options',
      component: () => dynamicImport(import('./pages/options')),
      name: ROUTES.BO_MERCHANT.OPTIONS.HOME,
      redirect: { name: childrenRoutes[0].name },
      children: childrenRoutes,
    },
  ]
}

const routes = [
  {
    name: ROUTES.BO_MERCHANT.OPTIONS.ADDRESS_BOOK,
    path: 'options/address-book',
    component: () => dynamicImport(import('./pages/address-book')),
  },
  {
    name: ROUTES.BO_MERCHANT.SHIPPING.CREATE_LABEL,
    path: 'create-shipping-label',
    component: () => dynamicImport(import('./pages/create-shipping-label')),
  },
  {
    path: 'international-onboarding',
    component: () => dynamicImport(import('./pages/international-onboarding')),
    redirect: {
      name: ROUTES.BO_MERCHANT.INTERNATIONAL_ONBOARDING.MARKETS,
    },
    children: [
      {
        name: ROUTES.BO_MERCHANT.INTERNATIONAL_ONBOARDING.MARKETS,
        path: 'markets',
        component: () =>
          dynamicImport(
            import('./pages/international-onboarding/steps/markets'),
          ),
      },
      {
        name: ROUTES.BO_MERCHANT.INTERNATIONAL_ONBOARDING.SHIPPING,
        path: 'shipping',
        component: () =>
          dynamicImport(
            import('./pages/international-onboarding/steps/shipping'),
          ),
      },
      {
        name: ROUTES.BO_MERCHANT.INTERNATIONAL_ONBOARDING.CUSTOMER_CARE,
        path: 'customer-care',
        component: () =>
          dynamicImport(
            import('./pages/international-onboarding/steps/customer-care'),
          ),
      },
      {
        name: ROUTES.BO_MERCHANT.INTERNATIONAL_ONBOARDING.PAYMENT,
        path: 'payment',
        component: () =>
          dynamicImport(
            import('./pages/international-onboarding/steps/payment'),
          ),
      },
      {
        name: ROUTES.BO_MERCHANT.INTERNATIONAL_ONBOARDING.PRICING_RULES,
        path: 'pricing',
        component: () =>
          dynamicImport(
            import('./pages/international-onboarding/steps/pricing-rules'),
          ),
      },
      {
        name: ROUTES.BO_MERCHANT.INTERNATIONAL_ONBOARDING.REVIEW,
        path: 'review',
        component: () =>
          dynamicImport(
            import('./pages/international-onboarding/steps/review'),
          ),
      },
      {
        name: ROUTES.BO_MERCHANT.INTERNATIONAL_ONBOARDING.CONFIRMATION,
        path: 'confirmation',
        component: () =>
          dynamicImport(
            import('./pages/international-onboarding/steps/confirmation'),
          ),
      },
    ],
  },
  {
    path: 'listings',
    name: ROUTES.BO_MERCHANT.LISTINGS.ACTIVE,
    component: () => dynamicImport(import('./pages/listings')),
    children: [
      {
        name: ROUTES.BO_MERCHANT.LISTINGS.MISSING_INFOS,
        path: 'missing-infos',
      },
      {
        name: ROUTES.BO_MERCHANT.LISTINGS.IN_VALIDATION,
        path: 'in-validation',
      },
      {
        name: ROUTES.BO_MERCHANT.LISTINGS.ARCHIVED,
        path: 'archived',
      },
    ],
  },
  {
    name: ROUTES.BO_MERCHANT.INSIGHTS,
    path: 'insights',
    component: () => dynamicImport(import('./pages/performances')),
  },
  {
    name: ROUTES.BO_MERCHANT.INSIGHTS_TABLEAU,
    path: 'insights/:tab(business|grades|quality-dashboard|quality-dashboard-details)',
    component: () => dynamicImport(import('./pages/performances')),
  },
  {
    path: 'listings/create/:productId',
    name: ROUTES.BO_MERCHANT.LISTINGS.CREATE.DETAILS,
    component: () => dynamicImport(import('./pages/listing-creation')),
  },
  {
    name: ROUTES.BO_MERCHANT.FEEDBACK,
    path: 'feedback',
    component: () => dynamicImport(import('./pages/feedback')),
  },
  {
    name: ROUTES.BO_MERCHANT.ONBOARDING.QUALITY_TEST,
    path: 'onboarding/quality-test',
    component: () => dynamicImport(import('./pages/onboarding/quality-test')),
  },
  {
    name: ROUTES.BO_MERCHANT.INVOICES.HOME,
    path: 'invoices',
    component: () => dynamicImport(import('./pages/invoices')),
    redirect: { name: ROUTES.BO_MERCHANT.INVOICES.PENDING },
    children: [
      {
        name: ROUTES.BO_MERCHANT.INVOICES.PENDING,
        path: 'pending',
        component: () => dynamicImport(import('./pages/invoices/tabs/pending')),
      },
      {
        name: ROUTES.BO_MERCHANT.INVOICES.PAST_INVOICES,
        path: 'past-invoices',
        component: () =>
          dynamicImport(import('./pages/invoices/tabs/pastInvoices')),
      },
      {
        name: ROUTES.BO_MERCHANT.INVOICES.GOODWILL_GESTURES,
        path: 'goodwill-gestures',
        component: () =>
          dynamicImport(import('./pages/invoices/tabs/GoodwillGestures')),
      },
      {
        name: ROUTES.BO_MERCHANT.INVOICES.COMPENSATION,
        path: 'seller-compensation',
        component: () =>
          dynamicImport(import('./pages/invoices/tabs/sellerCompensation')),
      },
    ],
  },
  {
    name: ROUTES.BO_MERCHANT.HOME,
    path: 'home',
    component: () => dynamicImport(import('./pages/home')),
  },
]

export default ({ marketplace }) => {
  return [
    {
      path: '/bo_merchant',
      component: () => dynamicImport(import('./layouts/backOffice')),
      meta: {
        auth: {
          required: true,
          redirection: { name: ROUTES.BO_MERCHANT.LOGIN },
        },
        merchant: {
          required: true,
          redirection: { name: ROUTES.BO_MERCHANT.LOGIN },
        },
      },
      children: [
        ...buybackRoutes,
        ...hyperwalletRoutes,
        ...routes,
        ...getOptionsRoutes(marketplace),
        ...insertIf(marketplace === MARKETPLACES.EU, pricingToolRoute),
        ...badoomRoutes,
      ],
    },
    {
      name: ROUTES.BO_MERCHANT.LOGIN,
      path: '/bo_merchant/login',
      component: () => dynamicImport(import('./pages/login')),
      meta: {
        notMerchant: {
          required: true,
          redirection: { name: ROUTES.BO_MERCHANT.HOME },
        },
      },
    },
    ...badoomRoutesNotNamespaced,
  ]
}
